<script>
	const routeContext = require('core/routeContext');
	const page = require('page');
	const accountService = require('services/accountService');
	const pubsub = require('events/pubsub');

	module.exports = {
		components: {
			'form-submitter': require('components/form-submitter.vue').default
		},
		data() {
			return {
				changePasswordForm: {}
			};
		},
		mounted() {
			this.verifyQueryParams();
		},
		methods: {
			verifyQueryParams: function () {
				if (
					!(routeContext.getQuery('classCode') || '').trim() ||
					!(routeContext.getQuery('studentName') || '').trim() ||
					!(routeContext.getQuery('username') || '').trim()
				) {
					page.redirect('/');
				}
			},
			changePassword: function (data, cb) {
				var classCode = routeContext.getQuery('classCode'),
					studentName = routeContext.getQuery('studentName'),
					username = routeContext.getQuery('username'),
					password = data.confirmedPassword;

				return accountService
					.studentChangePassword({
						u: username,
						p: password,
						cc: classCode,
						cp: data.currentPassword
					})
					.then(function (result) {
						pubsub.publish('message-success', 'Changed Password');

						page('/student-authentication?studentName=' + studentName + '&username=' + username + '&classCode=' + classCode);

						return result;
					});
			}
		}
	};
</script>
<template>
	<main class="padding-top-bottom-large">
		<div class="main main-box">
			<h1>Change Password</h1>
			<div class="content">
				<form-submitter
					:submit-to="changePassword"
					form-name="changePasswordForm"
					:form-data.sync="changePasswordForm"
					class="form form-signin"
					novalidate>
					<auto-form-row
						placeholder="Current Password"
						type="password"
						:data.sync="changePasswordForm.currentPassword"
						row-class="label-hidden-visually"
						novalidate
						required>
					</auto-form-row>
					<auto-form-row
						placeholder="New Password|Confirm New Password"
						type="confirmedPassword"
						:data.sync="changePasswordForm.confirmedPassword"
						row-class="label-hidden-visually"
						login-password="student"
						required>
					</auto-form-row>
					<auto-form-row
						:all-valid="changePasswordForm.allValid"
						row-class="-full-width"
						type="submit">
						Change Password
					</auto-form-row>
				</form-submitter>
			</div>
		</div>
	</main>
</template>
